import { BoxProps, ColorOptions } from '@jfs/ui-new'
import { Colors } from '../../util/util'

export const shadow = {
  shadowColor: '#00000029' as ColorOptions,
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.8,
  shadowRadius: 4,
  elevation: 3,
}

export const styles = {
  container: {
    shadowOffset: { width: 1, height: 1 },
    shadowRadius: 5,
    shadowColor: Colors.LIGHT_GREY,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: Colors.BORDER_COLOR,
    zIndex: 10,
    flex: 1,
    marginVertical: 16,
    marginHorizontal: 16,
    backgroundColor: 'WHITE',
    paddingHorizontal: 16,
    paddingVertical: 16,
    overflowY: 'auto',
    nativeID: 'showListScrollBar',
  } as BoxProps,
  tableContainer: (isLoading: boolean) =>
    ({
      flexGrow: 1,
      alignContent: 'center',
      marginTop: isLoading ? 24 : 0,
    } as BoxProps),
}
